export default __webpack_public_path__ + "static/media/who-developed-hero.bb01afc4.svg";